// extracted by mini-css-extract-plugin
export default {"price":"price__price___3yNiY","unit":"price__unit___1AZGv","from":"price__from___13Q8y"};